var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(!_vm.isLogged)?_c('router-view'):[_c('user-permissions'),_c('ets-nav-bar',{attrs:{"section":"admin"}}),_c('router-view')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }